//require('normalize.css/normalize.css');
require('styles/App.scss');

import React from 'react';
import ReactGA from 'react-ga';
import PubSub from 'pubsub-js';
import Header from './Header';
import Section from './Section';


//let yeomanImage = require('../images/yeoman.png');

class AppComponent extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			SPOTS: null,
			defaultLat: 48.8729380,
			defaultLng: 2.3598986,
			userLat: null,
			userLng: null
		}
	}

	componentDidMount(){
		//console.log("AppComponent componentDidMount")
		ReactGA.initialize('UA-86476415-1');
		ReactGA.pageview(window.location.pathname + window.location.search);

		PubSub.publish('STATUS', "FETCH ...");
		fetch('static/spots.json')
			.then(res => res.json())
			.then(data => {
				//console.log(data)
				this.setState({
					SPOTS: data
				})
			})
		
	}

	render() {
		if(!this.state.SPOTS){
			return (
				<div>Loading...</div>
			)
		}else{
			return (
				<div id="page">
					<Header />
					<Section spots={this.state.SPOTS} />
					
				</div>
			);
		}
		
	}
}

AppComponent.defaultProps = {
};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/Main.js